<template lang="pug">
vm-prompt(vm-size="medium" class="category-add" @vm-cancel="close" @vm-accept="compareSimilarity" @vm-close="close" @vm-action="deleteToQuoteConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalCategoryVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(vm-lg=7 vm-sm=6)
      .table-modal
        vm-table(:data="inOrdersCatalog.categories")
          template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                slot(v-if="column != 'total'") {{data[indextr][column]}}
              vm-td
                vm-button(@click="showDeleteAlert(tr)" icon="trash-2-outline" size="1.4rem" style="color: black" color="white")
    vm-col(vm-lg=5 vm-sm=6)
      b-form-group
        vm-input(:placeholder='$t("projects.type_placeholder")' :danger="$v.newRecord.type.$invalid && $v.newRecord.type.$model" :danger-text="$t('validation.required', { attribute: $t('projects.type') })" v-model="newRecord.type" :label='$t("projects.type")' required)
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalCategory',
  props: {
    newRecord: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    columns: [
      'id',
      'type'
    ],
    types: []
  }),
  validations: {
    newRecord: {
      type: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalCategoryVisible',
      'inOrdersCatalog',
      'categories'
    ]),
    getTitle () {
      return this.$t('projects.add_category')
    }
  },
  methods: {
    ...mapActions([
      'setModalCategoryVisible',
      'addCategory',
      'deleteCategory',
      'loadCatalog'
    ]),
    async saveRecord () {
      await this.addCategory(this.newRecord)
        .then(() => { this.loadCatalog({ filter: 'is_active=1', url: 'categories' }) })
    },
    async compareSimilarity () {
      const similars = await this.isCategoryRepeated()
      if (similars.similarCategories.length > 0) {
        const typesList = this.inOrdersCatalog.similarCategories.map(item => item.type).join(', ')
        this.$vm.dialog({
          color: 'warning',
          title: this.$t('strings.similar_values'),
          text: typesList,
          acceptText: this.$t('strings.save_anyway'),
          accept: () => { this.saveRecord() }
        })
      } else {
        this.saveRecord()
      }
    },
    async isCategoryRepeated () {
      await this.loadCatalog({ filter: `param=${this.newRecord.type},type&is_active=1`, url: 'categories', object: 'similarCategories' })
      return this.inOrdersCatalog
    },
    close () {
      this.setModalCategoryVisible(false)
    },
    showDeleteAlert (row) {
      this.$vm.dialog({
        color: 'warning',
        title: this.$t('strings.delete'),
        text: this.$t('strings.you_sure'),
        acceptText: this.$t('strings.delete'),
        accept: () => {
          this.deleteCategory({ id: row.id, type: row.type }).then(() => {
            this.loadCatalog({ filter: 'is_active=1', url: 'categories' })
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.category-add {
  z-index: 99999;
}

.table-modal {
  height: 25rem !important;
  margin-right: 15px;
  overflow: scroll
}
</style>
